import { Box, Stack } from "@mui/material";
import React, { ReactNode, useEffect, useState } from "react";

import parlors from "../../../constants/parlors_detail.json";

export function CTypeParlorList({
  title,
  binsoAveragePrice,
  sido,
  sigungu,
  CardViewType,
}: {
  sido?: string;
  sigungu?: string;
  title: string;
  binsoAveragePrice?: boolean;
  CardViewType: (res: any) => ReactNode;
}) {
  const parlorCardItems = sigungu
    ? parlors.filter((p) => String(p.sigungu) === String(sigungu))
    : parlors.filter((p) => String(p.sido) === String(sido));

  const [averagePrice, setaveragePrice] = useState(0);

  useEffect(() => {
    let price = 0;
    let binsoFullLength = 0;
    parlorCardItems.map((res) => {
      for (let i = 0; i < res.binsos.length - 1; i++) {
        price = price + Number(res.binsos[i].charge);
        binsoFullLength = binsoFullLength + 1;
      }
    });
    setaveragePrice(price / binsoFullLength);
  }, []);

  return (
    <Stack
      margin="20px 12px"
      padding="16px"
      style={{
        background: "white",
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.12)",
      }}
    >
      <h2 className="subtitle_18_sb" style={{ marginBottom: "4px" }}>
        {title}
      </h2>
      {/* {binsoAveragePrice && (
        <Box component="p" className="caption_12_r" mb="4px">
          전체 빈소 평균 비용(1일) : {Math.round(averagePrice).toLocaleString()}원
        </Box>
      )} */}
      <Box marginTop="6px" />
      <Stack component="ul" gap="16px">
        {parlorCardItems.map((res) => CardViewType(res))}
      </Stack>
    </Stack>
  );
}
